<template>
  <KTTable
    title="Estructura"
    subtitle="Lista de actividades"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_STRUCTURE"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_STRUCTURE } from "@/core/services/store/structures.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_STRUCTURE,
      endpoint: "dic_actividades",
      fields: [
        {
          key: "id_actividad",
          label: "Código Actividad",
          sortable: true
        },
        {
          key: "id_mercado",
          label: "Código Mercado",
          sortable: true
        },
        {
          key: "id_sector",
          label: "Código Sector",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Literal Actividad",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_actividad}`);
    }
  }
};
</script>
